import { render } from "./PopupTransitionWrapper.vue?vue&type=template&id=675914f6&scoped=true"
import script from "./PopupTransitionWrapper.vue?vue&type=script&lang=js"
export * from "./PopupTransitionWrapper.vue?vue&type=script&lang=js"

import "./PopupTransitionWrapper.vue?vue&type=style&index=0&id=675914f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675914f6"]])

export default __exports__